var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0H2.5C1.397 0 0.5 0.897 0.5 2V14C0.5 15.103 1.397 16 2.5 16H18.5C19.603 16 20.5 15.103 20.5 14V2C20.5 0.897 19.603 0 18.5 0ZM18.5 2V2.511L10.5 8.734L2.5 2.512V2H18.5ZM2.5 14V5.044L9.886 10.789C10.0611 10.9265 10.2773 11.0013 10.5 11.0013C10.7227 11.0013 10.9389 10.9265 11.114 10.789L18.5 5.044L18.502 14H2.5Z",
    fill: "#556EE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.f55e9b6a58e590557ac728a7ac048678.svg";
export { ForwardRef as ReactComponent };